import highlight from './highlight'

const install = function (Vue) {
  Vue.directive('npm r', highlight)
}

if (window.Vue) {
  window['highlight'] = highlight
  Vue.use(install); // eslint-disable-line
}

export default install
